// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
import {use_theme} from '../../../../hola/pub/settings_ctx';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import {Nav_menu} from './nav_menu';
import {Nav_user} from './nav_user';
import {use_navbar} from './use_navbar';
import storage from '/util/storage.js';
import styles from './nav.module.less';
import {use_pathname} from '../../../../hola/pub/lib/use_pathname';

const logo_links = {
    '/affiliate_frm': {to: '/pricing/premium?ref=affiliate_frm',
        target: '_blank', rel: 'noopener noreferrer'},
    '/download_ie': {to: null},
};

export const Nav = (props: ReturnType<typeof use_navbar>)=>{
    const {is_scrolled, has_user, headlogo,
        is_client, nomenu, nologin, nav_opt, cp_link, cp_after_login,
        with_cart, no_getstarted, cp_always_icon} = props;
    const {theme} = use_theme({def: 'toolip'});
    const variant = nav_opt?.transparent ? 'transparent' : 'default';
    const nav_cls = cn(styles.nav, theme.root, styles[variant], {
        [styles.scrolled]: is_scrolled,
    });
    const show_nav_menu = !headlogo && !nomenu;
    const {pathname} = use_pathname();
    const global_homepage = is_client ? storage.get('global_homepage') : '';
    const link_props = nav_opt?.logo_to ? {to: nav_opt.logo_to} :
        global_homepage ? {to: global_homepage} :
        logo_links[pathname] || {to: '/'};
    const logo = nav_opt?.logo || 'toolip/logo_black.svg';
    return <div className={nav_cls}>
      <div className={styles.container}>
        <Link {...link_props} className={styles.logo} data-clickid="nav_logo">
          <img src={toolip_img_url(logo)} alt={'Site logo'}/>
        </Link>
        {show_nav_menu && <Nav_menu visible/>}
        {headlogo || nologin ? <div/> : <Nav_user has_user={has_user}
          is_scrolled={is_scrolled} no_getstarted={no_getstarted}
          cp_link={cp_link} cp_after_login={cp_after_login}
          cp_always_icon={cp_always_icon}
          with_cart={with_cart}/>}
      </div>
    </div>;
};
